import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Build User-Centric Flutter Apps with a Reliable Flutter App
              Development Company in UK
            </h2>
            <p>
              As an award-winning Flutter Mobile app development company in
              London, we help you grow your digital presence. With the latest
              tech stack and innovative solutions, we build Flutter mobile apps
              that are compatible and operate on multiple devices, giving a
              native-like performance.
            </p>
            <p>
              You may hire Flutter app developers from us, who will create your
              Flutter application swiftly and effectively, ensuring high-quality
              outcomes. Our Flutter engineers also take care of evolving user
              demands & assist your app to stay ahead of the curve and remain
              competitive in the digital market.
            </p>
            <p>
              TekRevol is your partner in developing a legitimate Flutter mobile
              application by employing the digital technologies required to
              remain competitive in the UK market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../../images/location_new/fold11/Uk.webp"
                alt="iphone-ios-app-development-companies-london"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
